module.exports = __webpack_public_path__ + "media/Shoe_shop.d7f23f3b.mp3";